import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_ORGANIZATIONS = gql`
  query tenantList($filter: TenantFilter!) {
    tenantList(filter: $filter) {
      total
      data {
        id
        organizationName
        adminEmail
        phoneNumber
        userLimit
        projectLimit
        projectCount
        isDisabled
        timeZone
        ownerName
        userCount
        systemBranding
        projectRegisterLimit
        planName
        addOn
        tenantConfig {
          isRfiAutoNumberingEnabled
          ncrInstructionRequiredOnEqcFail
        }
        maxApprovalLevel
        registerMaxApprovalLevel
        inspectionAssetLimit
        instructionAssetLimit
        registerAssetLimit
        organizationType
        access
        featureConfig {
          stageMaxLimit
          issueTag
          issueRecommendation
        }
        subscription {
          validTill
          graceDays
          status
          createdAt
          updatedAt
          planObj {
            id
            name
            noOfDays
          }
        }
      }
    }
  }
`;

export const GET_PLANS = gql`
  query planList {
    planList {
      id
      name
    }
  }
`;

export const GET_ORGANIZATION_USERS = gql`
  query tenantUserList($filter: UserFilter!) {
    tenantUserList(filter: $filter) {
      total
      data {
        id
        name
        roles
        email
        isActive
        agencies {
          id
          name
          type
        }
        tenantUser {
          isActive
        }
      }
    }
  }
`;

export const GLOBAL_AGENCY_DROPDOWN_LIST = gql`
  query GlobalAgencyDropdownList($filter: AgencyFilter) {
    globalAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        name
        type
        tenantId
        contacts {
          id
          name
          phoneNo
          email
          designation
          agencyId
          createdBy
          tenantId
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;
